import React from 'react';
import PropTypes from 'prop-types';
import ProbabilitiesPopover from './ProbabilitiesPopover';
import { CROSSTAB_PROBABILITIES_NA_CONSTANT } from '../../../constants';

const DefaultCell = ({ bgColor, percent, value, height, crosstabviewFlag,
  rowData, colData, handleProbabilitiesEditClick }) => {
  percent = percent.replace(',', '').replace('**', '').replace('*', '');
  const style = { background: `-webkit-linear-gradient(left, ${bgColor} ${percent}, white ${percent}) transparent` };

  if (crosstabviewFlag) {
    style.height = height;
    style.display = 'flex';
    style.alignItems = 'center';
  }
  if (value === CROSSTAB_PROBABILITIES_NA_CONSTANT) {
    return (
      <ProbabilitiesPopover
        value={value}
        rowData={rowData}
        colData={colData}
        crosstabviewFlag={crosstabviewFlag}
        handleProbabilitiesEditClick={handleProbabilitiesEditClick}
      />
    );
  }
  return (
    <div
      style={style}
      title={value}
    >{value}</div>
  );
};

DefaultCell.propTypes = {
  bgColor: PropTypes.string,
  percent: PropTypes.string,
  value: PropTypes.string,
  rowData: PropTypes.Object,
  colData: PropTypes.Object,
  handleProbabilitiesEditClick: PropTypes.func,
};

export default DefaultCell;
